// Implementação web de `PlataformaMidia` (plataforma/tipos.ts): o cookie de sessão vai junto com `<img>`/`<audio>`
// na mesma origem, então a URL de `/api/eu/arquivos/:id` é usada direto. Quem baixa e avisa `load`/`error` é o próprio
// `<img>` (componente Foto/FotoSobre); "tentar de novo" troca a `key` do `<img>` (`tentativa`).
import { useCallback, useState, type ComponentProps } from "react";
import type { ArquivoApi } from "../tipos";

export function useArquivo(url: string | null | undefined): ArquivoApi {
  const [tentativa, setTentativa] = useState(0);
  const tentarDeNovo = useCallback(() => setTentativa((t) => t + 1), []);
  return {
    url: url ?? undefined,
    estado: url ? "pronta" : "erro",
    emCache: false,
    tentativa,
    tentarDeNovo,
  };
}

export function useUrlArquivo(url: string | null | undefined): string | undefined {
  return url ?? undefined;
}

export function ImagemApi(props: ComponentProps<"img">) {
  // o `alt` vem de quem usa (repasse de props)
  return props.src ? <img {...props} /> : null;
}
